<template>

    <div class="start__screen noselect">

        <h1 class="start__title">{{ $tc('stories_screen_1_text_3', 0, {name: data.value}) }}</h1>

        <p class="start__text start__middle-item">{{ $t('stories_screen_1_text') | capitalizeFirstLetter }}</p>

        <markdown class="start__text" :text="$t('stories_screen_1_text_2')" :color="'#5ea774'"></markdown>


    </div>

</template>

<script>

import Markdown from '@/components/Markdown'

export default {

    name: 'start',

    components: { Markdown },

    props: {

        data: {
            type: Object,
            default: () => {}
        }
    },

    methods: {}

}

</script>

<style scoped lang="scss">

    .start {
        &__screen {
            display: flex;
            flex-direction: column;
            width: 100%;
            height: 100%;
            align-items:  baseline;
            justify-content: center;
            padding: 24px;
            background-color: $rifle;
            color: $sand;
            text-align: left;
        }

        &__title {
            font-size: 48px;
            font-weight: bolder;
            color: $forest;
        }

        &__text {
            font-size: 28px;
            font-weight: bolder;
        }

        &__middle-item {
            margin: 32px 0 24px;

        }
    }

</style>
